import * as React from "react";
import { Divider } from "@mui/material";
import useDrive from "../../hooks/useDrive";
import { PERMISSIONS } from "../../config/appConst";
import FileUpload from "../FileUpload";
import CreateNewFolderForm from "../CreateNewFolderForm";
import FileAndFolderCopy from "../FileAndFolderCopy";
import { LayoutSwitch } from "../LayoutSwitch";
import styles from "./fileActionBar.module.css";

export default function DriveActionBar() {
  const { CurrentDrive } = useDrive();
  const canWrite = CurrentDrive?.drivePermission === PERMISSIONS.WRITE;

  return (
    <div className={styles.bar}>
      <div className={styles.left}>
        {canWrite && (
          <>
            <FileUpload parent={CurrentDrive.parent} />
            <CreateNewFolderForm parent={CurrentDrive.parent} />
            {CurrentDrive && <FileAndFolderCopy />}
            <Divider orientation="vertical" flexItem sx={{ borderColor: "var(--border)" }} />
          </>
        )}
      </div>
      <div className={styles.right}>
        <LayoutSwitch />
      </div>
    </div>
  );
}
